import { useQuery } from '@tanstack/react-query'
import instance from '../api'
import { PricingPlan } from '../../interfaces/pricingPlan'

const getPricingPlans = async (): Promise<PricingPlan[]> => {
  const response = await instance.get('/payment/pricing-plans/')
  return response.data.data
}

const usePricingPlans = ({ enabled }: { enabled: boolean }) => {
  return useQuery({
    queryKey: ['pricingPlans'],
    queryFn: () => getPricingPlans(),
    enabled,
  })
}

export default usePricingPlans
